<template>
  <main role="main">
      <Cabecera />
      <div class="c-form-info whitebg">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 offset-lg-2 c-form-info__wrapper redirect01">
              <div class="c-form-info__validacion">
                <div class="info" v-if="tipoSocDocs.length !== 0">
                  <h2> <strong>Espera tu Validación de </strong>correo electrónico</h2>
                  <p>En unos minutos le enviaremos un correo a la casilla <a href="#">{{ emailGlobal }}</a> con las instrucciones de validación necesarias para continuar con el proceso de postulación. <br>Por favor revise su bandeja de entrada y carpeta de spam.</p>
                  <p>Además, contarás con un número de solicitud para hacer seguimiento o continuar el proceso si es que es necesario.</p>
                </div>

                <div class="info" v-if="tipoSocDocs.length == 0">
                  <h2> <strong>Espera tu Validación de </strong>correo electrónico</h2>
                  <p>En unos minutos le enviaremos un correo a la casilla <a href="#">{{ emailStorage }}</a> con las instrucciones de validación necesarias para continuar con el proceso de postulación. <br>Por favor revise su bandeja de entrada y carpeta de spam.</p>
                  <p>Además, contarás con un número de solicitud para hacer seguimiento o continuar el proceso si es que es necesario.</p>
                </div>
              </div>
              <div class="c-form-info__documentos">
               <div class="info">
                  <h2> <strong>Documentos requeridos para el proceso</strong></h2>
                  <div >
                     <p>Para las siguientes etapas de postulación deberá tener a mano los siguientes datos y documentos en formato digital (jpg, png o pdf).</p>
                    <ul v-if="tipoSocDocs.length !== 0 && (postType == 1) && text">
                      <!-- <li>Memoria o CV de la empresa</li> -->
                      <!-- <li  v-for="(doc, index) in tipoSocDocs[0]" :key="index">
                        {{ doc }}.
                      </li> -->
                        <div v-for="(docs, index) in tipoSocDocs[0]" :key="index">
        
                          <div v-if=" docs == item1 "><p>{{docs}} <b>Certificados de:</b> </p></div>
                          <div v-if=" docs == item2 "><br><p>{{docs}} <b>Sociedades Colectivas:</b> </p></div>
                          <li v-if=" docs != item1  && docs != item2 ">{{docs}}</li>

                      </div>
                    </ul>

                    <ul v-else-if="text !== 'undefined'">
                      <li  v-for="(doc, index) in arrayText" :key="index">
                        {{ doc }}.
                      </li>
                    </ul>

                    <!-- <ul v-else-if="text == 'undefined' && tipSelectSoc == 'EIRL'">
                      <li  v-for="(doc, index) in arrayText" :key="index">
                        {{ doc }}.
                      </li>
                    </ul> -->

                    <div v-if="tipoSocDocs.length !== 0 && postType == 1">
                      <p>Carpeta Tributaria Especial que emite el SII. Esta contiene información adicional relacionada a los IVA’s e Impuestos a la Renta. Se deben seleccionar los siguientes contenidos:</p>
                      <ul>
                        <li>Representante Legal.</li>
                        <li>Conformación de la Sociedad.</li>
                        <li>Participación en Sociedad.</li>
                        <li>Sucursales.</li>
                        <li>Formulario 29 (12 meses).</li>
                        <li>Formulario 22 (2 años).</li>
                        <li> **SE EXIMEN DE ESTOS ANTECEDENTES LAS FUNDACIONES Y CORPORACIONES".</li>
                      </ul> 
                    </div>

                      
                  </div>

                  
                  <div v-if="(postType == 2) && (textPersonaNatural)">
                    <!-- <p>Para las siguientes etapas de postulación deberá tener a mano los siguientes datos y documentos en formato digital (jpg, png o pdf).</p> -->
                    <ul>
                      <li>
                        Fotocopia de Cédula de Identidad por ambos lados.
                      </li>
                      <!-- <li>
                        <b>Tener alguna profesión relacionada con la industria de la construcción, según lo establece la Ley General de Urbanismo y Construcciones, es decir: arquitectos, ingenieros civiles, constructores civiles e ingenieros en construcción.</b>
                      </li> -->
                      <li>
                        Currículum Profesional que acredite experiencia en el rubro de la construcción.
                      </li>
                      <li>
                        Copia simple de certificado de título.
                      </li>
                      <li>
                        Certificado de "Sociedades a las que pertenece el contribuyente" del SII.
                      </li>
                      <!-- <li>
                        <b>En caso de tener otras profesiones, acreditar experiencia laboral en la industria de la construcción.</b>
                      </li>
                      <li>
                        Currículum Profesional que acredite experiencia en el rubro de la construcción.
                      </li>
                      <li>
                        Copia simple de certificado de título.
                      </li>
                      <li>
                        <b>Que el ejercicio de la profesión lo realice en forma independiente, sin trabajadores a su cargo.</b>
                      </li>
                      <li>
                        <b>Que no sea accionista mayoritario o socio con más del 50% de los derechos sobre el capital social de alguna empresa vinculada directamente a la industria de la construcción que NO sea socia.</b>
                      </li> -->
                    </ul>
                   
                  </div>
                  

                  <!--<ul>
                    <li>Escritura de constitución</li>
                    <li>Transformaciones y modificaciones (max 10 adjuntos)</li>
                    <li>Memoria o CV de la empresa</li>
                    <li>Escritura social (S.R.L)</li>
                    <li>Escritura social (S.A)</li>
                    <li>Logo</li>
                  </ul> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
</template>

<script>
import Cabecera from './../components/Cabecera.vue'
import { mapState } from "vuex";
export default {
  name: 'SendSolicitud',
  components: {
    Cabecera,
  },
  data () {
    return {
     text: '',
     emailStorage: '',
     arrayText: [],
     tip: '',
     textPersonaNatural: '',
     item1 : '1. Cuando fueron constituidas según el Régimen Simplificado del Registro de Empresas y Sociedades. ',
     item2 : '2. Cuando fueron constituidas según el Código de Comercio y en sus Leyes especiales. ',

    }
  },
  methods: {


  },

  computed: {
    ...mapState(['emailGlobal', 'resLimitadaDocs', 'socResLimitadaDocs', 'tipoSocDocs', 'postType']),
  },

  created: function () {
    // console.log(this.tipoSocDocs.length);
    // console.log(localStorage.getItem('text'));
    this.text = localStorage.getItem('text');
    // console.log(this.text);
    this.emailStorage = localStorage.getItem('email');
    this.tip = localStorage.getItem('tipSelectSoc');
    // console.log(this.tip);
    
    this.textPersonaNatural = localStorage.getItem('textPN');
    this.arrayText = this.text.split(',');
    // console.log(this.arrayText);
    // console.log(this.postType);
    //window.location.reload(true);
    //window.location.replace('/')
    /*window.onbeforeunload = function(){
      return "Are you sure you want to close the window?";
    }*/
    setTimeout( () => this.$router.push({ path: '/'}), 100000);
  }
}
</script>